export default "__VITE_ASSET__fd5d83aa__"